export default "__VITE_ASSET__d19cb613__"